import React, { useEffect } from "react";
import { useState } from "react";
import './filter.component.scss';
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import { Tooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css'

const FilterApp = ({onLowerChange,lower,onUpperChange,upper,onStatusChange,applyFilter,status,completed,failed,inprogress,waiting,rejected,onTotalClear,onStatusClear}) => {
    const [totalRecordsLowerLimit, setTotalRecordsLowerLimit] = useState(lower);
    const [totalRecordsUpperLimit, setTotalRecordsUpperLimit] = useState(upper);
    const [statusSelection, setStatusSelection] = useState(status);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [invalidRecordsInput, setInvalidRecordsInput] = useState(null);

    const handleLowerLimitChange = (event) => {
        //When ever user enters or changes the value of lower limit
        const value = event.target.value;
        onLowerChange(value);
        //Select the filter as prospectcount
        setSelectedFilter("prospectCount");
        setTotalRecordsLowerLimit(value);
        //Check if the min contacts is less than upper limit
        if((parseInt(value, 10)>parseInt(totalRecordsUpperLimit, 10))){
            setInvalidRecordsInput("Min contacts cannot be more than Max contacts.");
        }
        else{
            setInvalidRecordsInput(null);
        }
      };
    
      const handleUpperLimitChange = (event) => {
        const value = event.target.value;
        setTotalRecordsUpperLimit(value);
        onUpperChange(value);
        //Check if the upper limit is more than the lower limit
        if((parseInt(value, 10)<parseInt(totalRecordsLowerLimit, 10))){
            setInvalidRecordsInput("Min contacts cannot be more than Max contacts.");
        }
        else{
            setInvalidRecordsInput(null);
        }
      };

      const handleCheckboxChange = (event) => {
        //Handles the changes in the project status selection
        const { value, checked } = event.target;
        let status = []
        if (checked) {
            status = [...statusSelection, value];
        //   setStatusSelection([...statusSelection, value]);
        } else {
            status = statusSelection.filter((status) => status !== value);
        //   setStatusSelection(statusSelection.filter((status) => status !== value));
        }
        //Call the handleproject status function in list component
        onStatusChange(status);
        setStatusSelection(status);
      };

      const handleClearProjectStatus = () => {
        onStatusClear();
      };
      const handleClearTotalRecords = () => {
        onTotalClear();
      }

      useEffect(() => {
        if(statusSelection){
            //Call the apply filter if status is selected
            // console.log("STATUSSELECTION");
        applyFilter("projectExecutionStatus");
        }
        
      }, [statusSelection]);
      useEffect(() => {
        //Call the apply filter if count is changed
        applyFilter("prospectCount"); 
        // console.log(totalRecordsLowerLimit);
      }, [totalRecordsLowerLimit,totalRecordsUpperLimit]);

    return (
        <Accordion>
            <Accordion.Item eventKey="0">
                <Accordion.Header data-tooltip-content="Filter by list status" data-tooltip-id="Filters">Status</Accordion.Header>
                <Accordion.Body className="p-3">
                    <label className="CheckboxContainer mb-1 mt-1 d-block">
                        <input
                            type="checkbox"
                            name="Status"
                            value="4"
                            checked={statusSelection.includes("4")}
                            onChange={handleCheckboxChange}
                            className=""
                        />
                        <span className="CheckedMark"></span>
                        <span className="ms-4 ps-1 dark-text lato-medium">Completed <span className="light-grey-text font-12 ms-1 d-none">({completed})</span></span>
                    </label>
                    <label className="CheckboxContainer mb-1 mt-1 d-block">
                        <input
                            type="checkbox"
                            name="Status"
                            value="1"
                            checked={statusSelection.includes("1")}
                            onChange={handleCheckboxChange}
                            className=""
                        />
                        <span className="CheckedMark"></span>
                        <span className="ms-4 ps-1 dark-text lato-medium">In Progress <span className="light-grey-text font-12 ms-1 d-none">({inprogress})</span></span>
                    </label>
                    <label className="CheckboxContainer mb-1 mt-1 d-block">
                        <input
                            type="checkbox"
                            name="Status"
                            value="5"
                            checked={statusSelection.includes("5")}
                            onChange={handleCheckboxChange}
                            className=""
                        />
                        <span className="CheckedMark"></span>
                        <span className="ms-4 ps-1 dark-text lato-medium">Failed <span className="light-grey-text font-12 ms-1 d-none">({failed})</span></span>
                    </label>
                    <label className="CheckboxContainer mb-1 mt-1 d-block">
                        <input
                            type="checkbox"
                            name="Status"
                            value="6"
                            checked={statusSelection.includes("6")}
                            onChange={handleCheckboxChange}
                            className=""
                        />
                        <span className="CheckedMark"></span>
                        <span className="ms-4 ps-1 dark-text lato-medium">Waiting <span className="light-grey-text font-12 ms-1 d-none">({waiting})</span></span>
                    </label>
                    <label className="CheckboxContainer mb-1 mt-1 d-block">
                        <input
                            type="checkbox"
                            name="Status"
                            value="7"
                            checked={statusSelection.includes("7")}
                            onChange={handleCheckboxChange}
                            className=""
                        />
                        <span className="CheckedMark"></span>
                        <span className="ms-4 ps-1 dark-text lato-medium">Rejected <span className="light-grey-text font-12 ms-1 d-none">({rejected})</span></span>
                    </label>
                    <div className="text-end font-12 poppins-medium primary-blue-text cursor-pointer" onClick={handleClearProjectStatus}>
                        Clear
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className="d-none">
                <Accordion.Header>Added by</Accordion.Header>
                <Accordion.Body>
                    <input type="text" className="form-control" />
                    <div className="text-end font-12 poppins-medium primary-blue-text cursor-pointer mt-2">
                        Clear
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className="d-none">
                <Accordion.Header>Added Date</Accordion.Header>
                <Accordion.Body>
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <Form.Check
                            type="radio"
                            id="Today"
                            label="Today"
                        />
                        <div className="light-grey-text font-12">14 Jun</div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <Form.Check
                            type="radio"
                            id="Yesterday"
                            label="Yesterday"
                        />
                        <div className="light-grey-text font-12">13 Jun</div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <Form.Check
                            type="radio"
                            id="Lastweek"
                            label="Last week"
                        />
                        <div className="light-grey-text font-12">4 - 10 Jun</div>
                    </div>

                    <div className="text-end font-12 poppins-medium primary-blue-text cursor-pointer mt-2">
                        Clear
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
                <Accordion.Header data-tooltip-content="Filter by number of contacts in list" data-tooltip-id="Filters">Total contacts</Accordion.Header>
                <Accordion.Body>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <input 
                            type="number"
                            className={`form-control ${invalidRecordsInput ? 'is-invalid' : ''}`}
                            placeholder="Min" 
                            value={totalRecordsLowerLimit} 
                            data-tooltip-content="Min contacts in list" data-tooltip-id="Filters"
                            onChange={handleLowerLimitChange}
                            />
                        </div>
                        <div className="px-2 light-grey-text">to</div>
                        <div>
                            <input 
                            type="number" 
                            className={`form-control ${invalidRecordsInput ? 'is-invalid' : ''}`}
                            placeholder="Max" 
                            data-tooltip-content="Max contacts in list" data-tooltip-id="Filters"
                            value={totalRecordsUpperLimit}
                            onChange={handleUpperLimitChange}/>
                        </div>
                    </div>
                    {invalidRecordsInput && (
                        <div className=" font-14  lato-regular text_error_message">
                            {invalidRecordsInput}
                        </div>
                    )}
                    <div className="text-end font-12 poppins-medium primary-blue-text cursor-pointer mt-2"onClick={handleClearTotalRecords}>
                        Clear
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Tooltip id = "Filters"/>
        </Accordion>
    );
}

export default FilterApp;